import { TitleCell, TitleRow } from '../../../../components/ReusableComponents/Table'

const BillingTitleRow = () => (
  <TitleRow style={{ position: 'sticky', top: 70 }}>
    <TitleCell>Id</TitleCell>
    <TitleCell>Hotel name</TitleCell>
    <TitleCell textAlign="center">Autopay</TitleCell>
    <TitleCell>Balance</TitleCell>
    <TitleCell>
      Late <br /> balance
    </TitleCell>
    <TitleCell>
      Last payment <br /> amount
    </TitleCell>
    <TitleCell>
      Last payment <br /> date
    </TitleCell>
    <TitleCell>Last email</TitleCell>
    <TitleCell>Notes</TitleCell>
  </TitleRow>
)

export default BillingTitleRow
